'use client';

import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { Filter } from '@terra/ui-design-system';
import { useDomainTreeFiltering } from '../../../contexts/SharedDomainTreeContext';
import {
  buildAssetsPathFilterItems,
  resolveAssetsPathNodeLabel,
} from './assets-path-filter.model';

export function AssetsPathFilter({
  value,
  onValueChange,
}: {
  value: string[];
  onValueChange: (nodeIds: string[]) => void;
}) {
  const t = useTranslations('proxy.assets.filters');
  const tFilter = useTranslations('designSystem.filter');
  const { domainTree } = useDomainTreeFiltering('application');
  const items = useMemo(
    () => buildAssetsPathFilterItems(domainTree),
    [domainTree],
  );

  return (
    <Filter
      id="path"
      density="compact"
      isMultiSelect
      contentWidth="320px"
      placeholder={t('path')}
      items={items}
      value={value}
      onChange={onValueChange}
      disabled={items.length === 0 && value.length === 0}
      resolveBadgeText={({ selectedValues }) => {
        const [onlyNodeId] = selectedValues;
        const onlyNode =
          selectedValues.length === 1
            ? domainTree?.nodeMap.get(onlyNodeId)
            : undefined;

        return onlyNode
          ? resolveAssetsPathNodeLabel(onlyNode)
          : `(${selectedValues.length}) ${tFilter('selected')}`;
      }}
    />
  );
}
